import React , {useState , useEffect } from "react";
import { AppBar, Avatar, Button, Toolbar, Typography } from "@material-ui/core";
import {Link , useLocation} from 'react-router-dom';
import useStyles from "./styles";
import memoriesLogo from "../../images/memories-Logo.png";
import memoriesText from "../../images/memories-Text.png";
import { useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import decode from 'jwt-decode';
export const Navbar = () => {
  const classes = useStyles();
  const dispatch = useDispatch()
  const navigate = useNavigate();
  const location=useLocation()
  const [user, setUser] = useState(JSON.parse(localStorage.getItem('profile')))
  const logout=()=>{
    dispatch({type:'LOGOUT'})
    navigate('/');
    setUser(null);
  }
  useEffect(()=>{
    
    if(user){
      const token= user.token;
      if(token){
        const decodedToken = decode(token);
        if(decodedToken.exp * 1000 < new Date().getTime()) logout();  
      }
    }

    // JWT

    setUser(JSON.parse(localStorage.getItem('profile')));

  },[location])
  return (
    <AppBar className={classes.appBar} position="static" color="inherit">
      <Link   to="/" className={classes.brandContainer}>
        <img src={memoriesText} alt="icon" height='45px'/>
        <img className={classes.image} src={memoriesLogo} alt="icon" height="40px" />
      </Link>
      <Toolbar className={classes.toolbar}>
          {
              user?(
                  <div className={classes.profile}>
                      <Avatar className={classes.purple} alt={user.result.name} src={user.result.imageUrl}>
                        {user.result.name.charAt(0)}
                      </Avatar>
                      <Typography className={classes.userName} variant="h6">{user.result.name}
                      </Typography>
                      <Button variant="contained" className={classes.logout} color="secondary" onClick={logout}>Logout</Button>
                  </div>

              )
              :
              (
                <Button component={Link} to="/auth" variant="contained" color="primary">
                  Sign in
                </Button>
              )

          }
      </Toolbar>
    </AppBar>
  );
};
